import { createContext, useContext } from 'react';

import type { BottomModalProps } from '@/features/popup/components/BottomModal';

export type BottomModalContextValues = {
  clearAllBottomModals: () => void;
  showBottomModal: (
    modal: Omit<BottomModalProps, 'onClose' | 'isVisible'>
  ) => void;
};

const defaultValues: BottomModalContextValues = {
  clearAllBottomModals: () => {},
  showBottomModal: () => {}
};

export const BottomModalContext =
  createContext<BottomModalContextValues>(defaultValues);
/**
 * Note: some elements wont work properly in bottom sheets, in such cases consider using the components directly
 * - showBottomModal should only be used if there are no properties passed to the parent via set methods
 */
export const useBottomModal = () => useContext(BottomModalContext);
